export type Doctor = {
  id: number
  name: string
  cpf: string
}

export type NewOrUpdatedDoctor = Omit<Doctor, 'id' | 'name'>

export type BiInfo = {
  displayBi?: boolean
  urlBi?: string | null
}

export const hasBiUrl = (bi?: Pick<BiInfo, 'urlBi'> | null): boolean =>
  Boolean(bi?.urlBi?.trim())

/** Médico: URL preenchida e Exibir Bi ativo */
export const hasActiveBi = (bi?: BiInfo | null): boolean =>
  Boolean(bi?.displayBi && hasBiUrl(bi))
